import { createFileRoute } from "@tanstack/react-router";
import { CatalogRoute } from "../screens/catalog-route";
export const Route = createFileRoute("/categories")({
  component: () => <CatalogRoute path="/categories" kind="Category" />,
});
